<div class="compose-field">
  <div class="compose-field__lines" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (row of rows; track row.id; let first = $first) {
      <div class="compose-field__line" [class.compose-field__line--continued]="row.continueControl.value" cdkDrag>
        <div class="compose-field__line-placeholder" *cdkDragPlaceholder></div>
        <span class="compose-field__handle" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </span>

        <div class="compose-field__fields">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="compose-field__column">
            <mat-label>{{ 'TRANS__IMPORT__COMPOSE_FIELD__COLUMN' | translate }}</mat-label>
            <!-- Not bound to columnControl: see `searchText`. -->
            <input
              #columnInput
              matInput
              type="text"
              autocomplete="off"
              [value]="columnText(row)"
              [matAutocomplete]="columnOptions"
              (focus)="onColumnFocus(row)"
              (input)="onColumnTyped(row, columnInput.value)"
              (blur)="onColumnBlur(row, columnOptions.isOpen)"
            >
            <mat-autocomplete
              #columnOptions="matAutocomplete"
              (optionSelected)="onColumnPicked(row, $event.option.value)"
              (closed)="onColumnListClosed(row, columnInput)"
            >
              <!-- See `optionsLineId`. -->
              @if (optionsLineId === row.id) {
                @for (col of matchingColumns(row); track col.name) {
                  <mat-option [value]="col.name">{{ col.name }}</mat-option>
                }
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="compose-field__prefix">
            <mat-label>{{ 'TRANS__IMPORT__COMPOSE_FIELD__PREFIX' | translate }}</mat-label>
            <input matInput [formControl]="row.prefixControl">
          </mat-form-field>

          @if (row.continueControl.value) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="compose-field__prefix compose-field__alone-prefix">
              <mat-label>{{ 'TRANS__IMPORT__COMPOSE_FIELD__ALONE_PREFIX' | translate }}</mat-label>
              <input matInput [formControl]="row.alonePrefixControl">
            </mat-form-field>
          }
        </div>

        <!-- The first line has no line above to continue or to stand apart
             from; a setting still shows there when set (after a reorder), so
             it can be cleared. A line that continues the line above starts no
             line of its own, so it has no blank line to ask for. -->
        @let offersContinue = !first || row.continueControl.value;
        @let offersBlankAbove = !row.continueControl.value && (!first || row.blankAboveControl.value);
        @if (offersContinue || offersBlankAbove) {
          <div class="compose-field__options">
            @if (offersContinue) {
              <mat-checkbox
                class="compose-field__continue"
                [formControl]="row.continueControl"
                (change)="onContinueChanged(row, $event.checked)"
              >
                {{ 'TRANS__IMPORT__COMPOSE_FIELD__CONTINUE_LINE' | translate }}
              </mat-checkbox>
            }
            @if (offersBlankAbove) {
              <mat-checkbox class="compose-field__blank-above" [formControl]="row.blankAboveControl">
                {{ 'TRANS__IMPORT__COMPOSE_FIELD__BLANK_LINE_ABOVE' | translate }}
              </mat-checkbox>
            }
          </div>
        }

        <button
          mat-icon-button
          type="button"
          class="compose-field__remove"
          (click)="removeLine.emit(row)"
          [attr.aria-label]="'TRANS__IMPORT__COMPOSE_FIELD__REMOVE_LINE' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>

        @if (previewFor(row)) {
          <p class="compose-field__preview">
            <span class="compose-field__preview-label">{{ 'TRANS__IMPORT__PREVIEW' | translate }}:</span>
            {{ previewFor(row) }}
          </p>
        }
      </div>
    }
  </div>

  @if (!rows.length) {
    <p class="compose-field__hint">{{ 'TRANS__IMPORT__COMPOSE_FIELD__NO_LINES' | translate }}</p>
  } @else if (previewResult(); as result) {
    <p class="compose-field__result-preview">
      <span class="compose-field__preview-label">{{ 'TRANS__IMPORT__COMPOSE_FIELD__RESULT_PREVIEW' | translate }}:</span>
      <span class="compose-field__result-value">{{ result }}</span>
    </p>
  }

  <button mat-stroked-button type="button" (click)="addLine.emit()">
    <mat-icon>add</mat-icon>
    <span class="bold uppercase">{{ 'TRANS__IMPORT__COMPOSE_FIELD__ADD_LINE' | translate }}</span>
  </button>
</div>
